(function() {
    'use strict';

    angular.module('user')
        .controller('ClientListController', ClientListController);

    ClientListController.$inject = ['$state', 'clientDataSrvc', 'clientSrvc', 'lodashService', 'notificationSrvc', 'clientMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'clientPermissionsConst', 'checkModelPermissionsSrvc', 'filterQuerySrvc', 'siteDataSrvc'];

    function ClientListController($state, clientDataSrvc, clientSrvc, lodashService, notificationSrvc, clientMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, clientPermissionsConst, checkModelPermissionsSrvc, filterQuerySrvc, siteDataSrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.clientRows = [];
        self.clientCols = [{
            title: 'ID',
            value: 'pk',
            type: 'number',
            searchable: true,
            orderable: true,
        }, {
            title: 'Imię',
            value: 'user.first_name',
            type: 'text',
            searchable: true,
            orderable: true,
        }, {
            title: 'Nazwisko',
            value: 'user.last_name',
            type: 'text',
            searchable: true,
            orderable: true,
        }, {
            title: 'Adres e-mail',
            value: 'user.email',
            type: 'text',
            searchable: true,
            orderable: true,
        }, {
            title: 'Główne konto',
            value: 'main_account',
            type: 'text',
            searchable: true,
            orderable: true,
        }, {
            title: 'Sklep',
            value: 'company_localization_display',
            orderValue: 'company_localization',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Grupa rabatowa',
            value: 'discount_group',
            type: 'text',
            searchable: true,
            orderable: false
        }, {
            title: 'Konto aktywne',
            value: 'user.is_active',
            type: 'boolean',
            searchable: false,
            orderable: true
        }];
        self.modelPermissions = clientPermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'user.date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'user.date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'user.last_modified_by'
        }];

        self.searchQuery = {
            pk: null,
            'user.first_name': null,
            'user.last_name': null,
            'user.email': null,
            company_localization_display: null,
            discount_group: null,
            main_account: null,
            ordering: null
        };

        self.filterData = {
            site_pk: null
        };

        self.contextMenu = [{
            text: 'Aktywuj',
            displayed: hasEditPermissions,
            enabled: function($itemScope, $event, modelValue) {
                return !$itemScope.row.user.is_active;
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                return clientSrvc.activate($itemScope.row);
            }
        }];

        self.onClick = onClick;
        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.isAllClients = isAllClients;
        self.filterAllClients = filterAllClients;
        self.isActiveClients = isActiveClients;
        self.filterActiveClients = filterActiveClients;
        self.isInactiveClients = isInactiveClients;
        self.filterInactiveClients = filterInactiveClients;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.changeFilter = changeFilter;

        self.isCanDisplaySites = false;
        self.siteOptions = [];
        self.initSiteOption = initSiteOption;

        activate();

        function activate() {
            self.isCanDisplaySites = canDisplaySites();
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getSiteOptions(getClients);
        }

        function getClients(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    is_active: $state.params.is_active,
                    client_pk: self.searchQuery.pk,
                    first_name: self.searchQuery['user.first_name'],
                    last_name: self.searchQuery['user.last_name'],
                    email: self.searchQuery['user.email'],
                    company_localization_display: self.searchQuery.company_localization_display,
                    discount_group: self.searchQuery.discount_group,
                    main_account: self.searchQuery.main_account,
                    ordering: self.searchQuery.ordering,
                    site_pk: self.filterData.site_pk,
                };
            }
            return clientDataSrvc.list(
                filterObj
            ).$promise.then(
                function(response) {
                    self.clientRows = response.results;
                    self.pageOpts.count = response.count;
                    return response;
                },
                function(response) {
                    if (response.status === 404 && filterObj.page !== 1) {
                        checkSearchSrvc.recall(filterObj, getClients);
                    }
                }
            ).finally(
                function(response) {
                    self.loading = false;
                    return response;
                }
            );
        }

        function onClick(row) {
            $state.go('layout.client.details', { pk: row.pk });
        }

        function onCreate() {
            $state.go('layout.client.create');
        }

        function onEdit(row) {
            $state.go('layout.client.update', { pk: row.pk });
        }

        function onDelete(row) {
            return clientSrvc.remove(row, function(response) {
                notificationSrvc.notification("success", clientMessagesConst.delete);
                lodashService.remove(self.clientRows, { pk: row.pk });
                return response;
            });
        }

        function hasEditPermissions() {
            return !checkModelPermissionsSrvc.isDenied(
                clientPermissionsConst.update);
        }

        function isAllClients() {
            return $state.params.is_active === undefined;
        }

        function filterAllClients() {
            $state.go('layout.client.list', { is_active: undefined });
        }

        function isActiveClients() {
            return $state.params.is_active === '1';
        }

        function filterActiveClients() {
            $state.go('layout.client.list', { is_active: '1' });
        }

        function isInactiveClients() {
            return $state.params.is_active === '0';
        }

        function filterInactiveClients() {
            $state.go('layout.client.list', { is_active: '0' });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getClients();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getClients();
        }

        function changeFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getClients();
        }

        function initSiteOption(){
            for (var index in self.siteOptions) {
                var optionPk = self.siteOptions[index].pk
                if (optionPk === config.siteId && self.filterData.site_pk === null){
                    self.filterData.site_pk = optionPk;
                }
            }
        }

        function getSiteOptions(callback) {
            if (self.isCanDisplaySites) {
                var siteIds = checkModelPermissionsSrvc.getPermittedSiteIds(clientPermissionsConst.view)
                return siteDataSrvc.getFieldOpts({"ids": siteIds}).$promise.then(
                    function(response) {
                        self.siteOptions = response.results;
                        initSiteOption();
                        callback();
                    });
            } else {
                callback();
            }
        }

        function canDisplaySites() {
            var ids = checkModelPermissionsSrvc.getPermittedSiteIds(clientPermissionsConst.view)
            return ids.length > 1;
        }
    }
})();
